var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import _ from 'lodash';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { UrlHelper } from '../../helper/UrlWrapper';
import { summaries } from '../../helper/util';
import GLOBAL_VUE from '../../globalVue';
import StockInitService from '../../api/StockInitService';
import AddDialog from './components/GoodAdd.vue';
import Header from './components/AddHeader.vue';
import TableHeaderToolTip from '../../common/components/TableHeaderToolTip';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
import moment from 'moment';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
var EStockType;
(function (EStockType) {
    EStockType[EStockType["STOCK"] = 1] = "STOCK";
    EStockType[EStockType["NO_STOCK"] = 2] = "NO_STOCK";
})(EStockType || (EStockType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.data = [];
        _this.formData = {
            order_id: '',
            stock_type: 1,
            organ_id: '',
            depot_id: '',
            order_icomment: '',
        };
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.eStockType = EStockType;
        _this.orderid = '';
        _this.handletype = 0;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.goods_format_ids = [];
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        this.service = StockInitService.getInstance();
        if (this.storeInfo) {
            this.handletype = 1;
            this.formData['organ_id'] = this.storeInfo.organ_id;
            this.formData['depot_id'] = this.storeInfo.depot_id;
        }
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 300;
        }, 300);
    };
    default_1.prototype.dateChange = function (row) {
        row.expire_date = this.resetDate(row.production_date, row.shelflife);
    };
    default_1.prototype.resetDate = function (date, days) {
        return date
            ? moment(date)
                .add(days > 0 ? days - 1 : 0, 'days')
                .format('YYYY-MM-DD')
            : '';
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
        };
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            var currentDay = moment().format('YYYY-MM-DD');
            data.order_detail.map(function (good) {
                good.production_date = good.production_date || currentDay;
                good.shelflife = good.shelflife || 0;
                good.expire_date = good.expire_date || _this.resetDate(good.production_date, good.shelflife);
                return good;
            });
            var goods_format_ids = (data.order_detail || []).map(function (good) {
                return good.goods_format_id;
            });
            _this.goods_format_ids = goods_format_ids || [];
            _this.formData = Object.assign({}, _this.formData, data);
            _this.data = data.order_detail || [];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.calculate = function (row) {
        var taxMoney;
        if (row.order_detail_money && (row.order_detail_tax_rate || row.order_detail_tax_rate === 0)) {
            taxMoney = (row.order_detail_money / (1 + row.order_detail_tax_rate)) * row.order_detail_tax_rate;
            taxMoney = new Number(taxMoney).toFixed(4);
            row.order_detail_tax_money = taxMoney;
            row.order_detai_after_money = new Number(row.order_detail_money - row.order_detail_tax_money).toFixed(4);
            return taxMoney;
        }
        return taxMoney;
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ['order_detail_money', 'order_detai_after_money', 'order_detail_tax_money'];
        sums = summaries(param, showSum);
        sums[0] = '';
        sums[1] = '合计';
        return sums;
    };
    default_1.prototype.copyGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.selections.map(function (item) {
            var currentIndex = _this.data.findIndex(function (v) { return v.goods_id === item.goods_id; });
            var copyItem = _.cloneDeep(item);
            _this.data.splice(currentIndex, 0, copyItem);
        });
        this.$refs.multipleTable.clearSelection();
    };
    default_1.prototype.save = function () {
        var _this = this;
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            stock_type: formData.stock_type,
            organ_id: formData.organ_id,
            depot_id: formData.depot_id,
            order_icomment: formData.order_icomment,
            order_detail: JSON.stringify(this.data.map(function (v) {
                return {
                    goods_id: v.goods_id,
                    goods_format_id: v.goods_format_id,
                    goods_format_name: v.goods_format_name,
                    stock_amount: v.stock_amount,
                    order_detail_uprice: v.order_detail_uprice,
                    order_detail_money: v.order_detail_money,
                    order_detail_icomment: v.order_detail_icomment,
                    production_date: v.production_date,
                    shelflife: v.shelflife,
                    expire_date: v.expire_date,
                };
            })),
        };
        if (this.orderid) {
            params = Object.assign({}, params, { order_id: this.orderid });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .addSave(params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(['_trackEvent', '修改期初单', '保存', '保存']);
            }
            else {
                window._czc.push(['_trackEvent', '添加期初单', '保存', '保存']);
            }
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.saveAjax = function () {
        var _this = this;
        if (!this.checkSave()) {
            return;
        }
        var formData = this.formData;
        var params = {
            stock_type: formData.stock_type,
            organ_id: formData.organ_id,
            depot_id: formData.depot_id,
            order_icomment: formData.order_icomment,
            order_detail: JSON.stringify(this.data.map(function (v) {
                return {
                    goods_id: v.goods_id,
                    goods_format_id: v.goods_format_id,
                    stock_amount: v.stock_amount,
                    order_detail_uprice: v.order_detail_uprice,
                    order_detail_money: v.order_detail_money,
                    order_detail_icomment: v.order_detail_icomment,
                    production_date: v.production_date,
                    shelflife: v.shelflife,
                    expire_date: v.expire_date,
                };
            })),
        };
        if (this.orderid) {
            params = Object.assign({}, params, { order_id: this.orderid });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .addSave(params)
            .then(function (res) {
            _this.getDetail();
            loadingInstance.close();
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.checkSave = function () {
        if (!this.canHandleGoods()) {
            return false;
        }
        var flag = true, msg = [];
        if (this.formData.stock_type == 1) {
            this.data.map(function (row) {
                if (!row.stock_amount || row.stock_amount < 0) {
                    flag = false;
                    msg.push('期初库存必填，并且不能为负数');
                }
                if (!row.order_detail_uprice || row.order_detail_uprice < 0) {
                    flag = false;
                    msg.push('单价不能为负数');
                }
                if (!row.order_detail_money || row.order_detail_money < 0) {
                    flag = false;
                    msg.push('含税金额必填，并且不能为负数');
                }
            });
        }
        if (!flag) {
            this.$message.warning('货品信息不可为空，并且不能为负数。');
            return false;
        }
        return true;
    };
    default_1.prototype.canHandleGoods = function () {
        if (!this.formData.organ_id) {
            this.$message.warning('请选择机构');
            return false;
        }
        if (!this.formData.depot_id) {
            this.$message.warning('请选择仓库');
            return false;
        }
        return true;
    };
    default_1.prototype.importFile = function () {
        if (!this.canHandleGoods()) {
            return;
        }
        this.dialogTableVisible = true;
        this.setUploadType('beford');
    };
    default_1.prototype.emptyOrderDetail = function () {
        this.data = [];
    };
    default_1.prototype.handleGoodsFieldDiffOrderField = function (res, type) {
        var _this = this;
        var currentDay = moment().format('YYYY-MM-DD');
        return res.map(function (v, index) {
            var tmp = {
                goods_id: v.goods_id,
                goods_format_id: v.goods_format_id,
                goods_name: v.goods_name,
                goods_code: v.goods_code,
                inventory_unit_name: v.inventory_unit_name,
                goods_format_name: v.goods_format_name,
                order_detail_tax_rate: v.order_detail_tax_rate === undefined ? v.tax_rate : v.order_detail_tax_rate,
                stock_amount: v.stock_amount || '',
                production_date: v.production_date || currentDay,
                shelflife: v.shelflife || 0,
                expire_date: v.expire_date || _this.resetDate(v.production_date || currentDay, v.shelflife || 0),
                order_detail_uprice: v.order_detail_uprice || '',
                order_detail_money: v.order_detail_money || '',
                order_detai_after_money: v.order_detai_after_money || '',
                order_detail_tax_money: v.order_detail_tax_money || '',
                order_detail_icomment: v.order_detail_icomment || '',
            };
            if (type == 'import') {
                tmp.order_detail_uprice = v.goods_price;
            }
            return tmp;
        });
    };
    default_1.prototype.toAddGood = function () {
        var _this = this;
        if (!this.canHandleGoods()) {
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
            },
        }, {
            title: '添加货品',
            width: 900,
            height: 550,
        });
        dialog.instance.$on('submit', function (res) {
            res = _this.handleGoodsFieldDiffOrderField(res);
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(['_trackEvent', '修改期初单', '添加货品', '添加货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加期初单', '添加货品', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(['_trackEvent', '修改期初单', '删除货品', '删除货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加期初单', '删除货品', '删除货品']);
            }
        }, function (err) { });
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type == 'stock_amount' || type == 'order_detail_uprice') {
            if (row.stock_amount && row.order_detail_uprice) {
                row.order_detail_money = new Number(row.stock_amount * row.order_detail_uprice).toFixed(4);
            }
        }
        else if (type == 'stock_amount' || type == 'order_detail_money') {
            if (row.stock_amount && row.order_detail_money) {
                row.order_detail_uprice = new Number(row.order_detail_money / row.stock_amount).toFixed(4);
            }
        }
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split('.'), fileType = name[name.length - 1];
        if (fileType == 'xlsx' || fileType == 'xls') {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error('文件只能是xlsx或xls');
        return false;
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = '';
            url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
            this.data = this.handleGoodsFieldDiffOrderField(data.goods_list || [], 'import').concat(this.data);
            if (this.handleStatus === EHanldeStatus.Edit && data.goods_list && data.goods_list.length) {
                this.saveAjax();
            }
            if (this.handleStatus === EHanldeStatus.Edit) {
                window._czc.push(['_trackEvent', '修改期初单', '导入货品', '导入货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加期初单', '导入货品', '导入货品']);
            }
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || '网络异常，请重新导入';
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || '网络异常，请重新导入';
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = '';
            this.setUploadType('beford');
        }
        else {
            this.setUploadType('after');
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType('importing');
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '税额=含税金额/(1+税率)*税率',
                            placement: 'bottom',
                        },
                    }, '税额');
                },
            },
        }),
        auth(nameDict["库存初始化"], true)
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
